import { Link } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function UrologyPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d62j4380h9ov63emh8dg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
      }
    } catch (error) {
      setFormStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#F5F3FF] via-white to-[#FAF5FF] overflow-hidden">
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="max-w-xl">
              <div className="inline-block px-4 py-2 bg-[#7C3AED]/10 rounded-full text-[#7C3AED] text-sm font-medium mb-6">
                Urologists & Men's Health Physicians
              </div>
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                Attract More Patients Seeking Men's Health & Urology Care
              </h1>
              <p className="text-xl text-gray-600 mb-8 leading-relaxed">
                HIPAA-compliant digital marketing and automated patient acquisition for urologists and men's health physicians specializing in hormone therapy, sexual health, and wellness.
              </p>
              <div className="flex flex-wrap gap-4">
                <a href="#contact-form" className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#7C3AED] to-[#A855F7] text-white rounded-lg font-semibold hover:shadow-lg transition-all whitespace-nowrap">
                  Book Free Strategy Call
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
                <Link to="/services/marketing-automation" className="inline-flex items-center px-8 py-4 bg-white text-[#7C3AED] rounded-lg font-semibold hover:bg-[#7C3AED]/5 transition-all border-2 border-[#7C3AED] whitespace-nowrap">
                  See Our Automation Platform
                </Link>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/32eb7437146fa661a6f75c2537e6e0b8.jpg"
                alt="Urology Practice"
                className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Challenges Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Marketing Challenges for Urology & Men's Health Practices
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We understand the unique obstacles facing urologists and men's health specialists
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-user-search-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Sensitive Topic Marketing</h3>
              <p className="text-gray-600">
                Marketing men's health, sexual wellness, and hormone therapy requires discretion and trust-building.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-search-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Low Online Visibility</h3>
              <p className="text-gray-600">
                Men searching for testosterone therapy, ED treatment, or men's health specialists can't find your practice.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-phone-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Missed Inquiries</h3>
              <p className="text-gray-600">
                Patient inquiries go unanswered when you're in surgery or clinic, leading to lost appointments.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-user-heart-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Patient Hesitation</h3>
              <p className="text-gray-600">
                Men often delay seeking care for sensitive health issues, requiring education and trust-building.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-team-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Competition</h3>
              <p className="text-gray-600">
                Standing out from other urologists and men's health clinics in your market.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <div className="w-14 h-14 bg-purple-100 rounded-lg flex items-center justify-center mb-6">
                <i className="ri-shield-cross-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">HIPAA Compliance</h3>
              <p className="text-gray-600">
                Ensuring all marketing tools and patient communications meet strict healthcare privacy requirements.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Solutions Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Our HIPAA-Compliant Marketing Solutions
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Proven strategies designed specifically for urology and men's health practices
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img 
                src="https://readdy.ai/api/search-image?query=professional%20male%20urologist%20doctor%20consulting%20with%20male%20patient%20about%20mens%20health%20and%20wellness%2C%20modern%20medical%20office%2C%20doctor%20patient%20consultation%2C%20mens%20health%20specialist%2C%20urological%20care%20consultation&width=600&height=400&seq=uro1&orientation=landscape"
                alt="Urologist consultation"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Discreet, Automated Patient Acquisition
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Our marketing automation platform captures and nurtures leads with sensitivity and professionalism while you focus on patient care.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">Instant Response:</strong> Automated follow-up within minutes of every inquiry</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">Educational Content:</strong> Automated sequences that build trust and educate patients</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">Private Booking:</strong> Discreet appointment scheduling that respects patient privacy</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-2xl text-purple-600 mr-3 mt-1"></i>
                  <span className="text-gray-700"><strong className="text-gray-900">HIPAA-Conscious:</strong> Secure systems designed for healthcare compliance</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-violet-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Comprehensive Marketing Services for Your Practice
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Everything you need to attract and convert more patients
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Link to="/services/medical-seo" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-search-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Medical SEO</h3>
              <p className="text-gray-600 mb-4">
                Rank #1 for "urologist near me," "men's health doctor," and testosterone therapy searches in your area.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/medical-website-design" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-layout-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Website Design</h3>
              <p className="text-gray-600 mb-4">
                Professional, discreet websites that build trust and drive confidential appointment bookings.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/healthcare-ppc" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-advertisement-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Google & Meta Ads</h3>
              <p className="text-gray-600 mb-4">
                HIPAA-compliant paid advertising targeting men actively seeking urology and men's health care.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/content-marketing" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-article-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Content Marketing</h3>
              <p className="text-gray-600 mb-4">
                Educational content about men's health, testosterone, and urology that establishes your authority.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/reputation-management" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Reputation Management</h3>
              <p className="text-gray-600 mb-4">
                Build trust with more 5-star reviews from satisfied patients across healthcare directories.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>

            <Link to="/services/marketing-automation" className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-all border border-gray-100 group">
              <div className="w-14 h-14 bg-gradient-to-br from-purple-600 to-violet-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className="ri-robot-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Marketing Automation</h3>
              <p className="text-gray-600 mb-4">
                Never miss a lead with automated nurturing, follow-up, and patient engagement systems.
              </p>
              <span className="text-purple-600 font-semibold group-hover:underline">Learn More →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Trusted by Leading Urologists & Men's Health Physicians
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-8 rounded-xl border border-purple-100">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20male%20urologist%20doctor%20headshot%20portrait%2C%20mens%20health%20specialist%2C%20confident%20medical%20professional%2C%20urology%20expert&width=80&height=80&seq=urotest1&orientation=squarish"
                  alt="Dr. Mark Stevens"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold text-gray-900">Dr. Mark Stevens, MD</div>
                  <div className="text-sm text-gray-600">Urology & Men's Health</div>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed">
                "MillionDollarMed transformed our patient acquisition. Their discreet, professional approach to marketing men's health services has increased our new patient volume by 165% in 8 months. The automation platform ensures we never miss an inquiry."
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-violet-50 p-8 rounded-xl border border-purple-100">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20male%20urologist%20doctor%20headshot%20portrait%2C%20testosterone%20therapy%20specialist%2C%20experienced%20mens%20health%20physician%2C%20confident%20healthcare%20provider&width=80&height=80&seq=urotest2&orientation=squarish"
                  alt="Dr. James Richardson"
                  className="w-16 h-16 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-bold text-gray-900">Dr. James Richardson, MD</div>
                  <div className="text-sm text-gray-600">Men's Health & Hormone Therapy</div>
                </div>
              </div>
              <div className="flex mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed">
                "Finally found a marketing partner who understands men's health marketing. Their SEO strategy has us ranking #1 for testosterone therapy in our region, and the automated follow-up converts leads while maintaining patient privacy. Excellent!"
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact-form" className="py-20 bg-gray-50">
        <div className="max-w-3xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Book Your Free Strategy Call
            </h2>
            <p className="text-xl text-gray-600">
              Let's discuss how we can help grow your urology or men's health practice with HIPAA-compliant marketing.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="bg-white p-8 md:p-12 rounded-2xl shadow-lg" data-readdy-form id="urology-strategy-form">
            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="name" className="block text-sm font-semibold text-gray-700 mb-2">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="Dr. John Smith"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">
                  Email Address <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="doctor@practice.com"
                />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="phone" className="block text-sm font-semibold text-gray-700 mb-2">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="(555) 123-4567"
                />
              </div>
              <div>
                <label htmlFor="practice" className="block text-sm font-semibold text-gray-700 mb-2">
                  Practice Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="practice"
                  name="practice"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                  placeholder="Your Practice Name"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="specialty" className="block text-sm font-semibold text-gray-700 mb-2">
                Specialty Focus <span className="text-red-500">*</span>
              </label>
              <select
                id="specialty"
                name="specialty"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
              >
                <option value="">Select your specialty</option>
                <option value="urology">Urology</option>
                <option value="mens-health">Men's Health</option>
                <option value="testosterone-therapy">Testosterone Therapy</option>
                <option value="sexual-health">Sexual Health</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="mb-6">
              <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                What are your biggest marketing challenges? <span className="text-red-500">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                required
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm resize-none"
                placeholder="Tell us about your practice goals and challenges..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">Maximum 500 characters</p>
            </div>

            <div className="mb-6">
              <label className="flex items-start">
                <input
                  type="checkbox"
                  name="consent"
                  required
                  className="mt-1 mr-3"
                />
                <span className="text-sm text-gray-600">
                  I agree to receive communications from MillionDollarMed. All information is handled in accordance with HIPAA guidelines.
                </span>
              </label>
            </div>

            <button
              type="submit"
              className="w-full bg-gradient-to-r from-purple-600 to-violet-600 text-white py-4 rounded-lg font-semibold hover:from-purple-700 hover:to-violet-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Book My Free Strategy Call
            </button>

            {formStatus === 'success' && (
              <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                <p className="text-green-800 text-center font-semibold">
                  Thank you! We'll contact you within 24 hours to schedule your strategy call.
                </p>
              </div>
            )}

            {formStatus === 'error' && (
              <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-red-800 text-center font-semibold">
                  Something went wrong. Please try again or call us directly.
                </p>
              </div>
            )}
          </form>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-gradient-to-br from-[#0D9488] to-[#14B8A6]">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Grow Your Urology Practice?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join leading urologists and men's health physicians who trust MillionDollarMed for HIPAA-compliant marketing and automated patient acquisition.
          </p>
          <a href="#contact-form" className="inline-flex items-center px-8 py-4 bg-white text-[#0D9488] rounded-lg font-semibold hover:bg-gray-50 transition-all text-lg whitespace-nowrap">
            Schedule Your Free Consultation
            <i className="ri-calendar-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
